/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { getEnvLevel } from "./src/utils/constants/endpoints";

export const onClientEntry = () => {
  const envLevel = getEnvLevel();
  const env = envLevel === 'prod' ? 'prod' : 'nonprod';

  datadogLogs.init({
    clientToken: process.env.GATSBY_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  datadogRum.init({
    applicationId: process.env.GATSBY_DD_APP_ID,
    clientToken: process.env.GATSBY_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.GATSBY_DD_SERVICE,
    sampleRate: 100,
    profilingSampleRate: 25,
    trackLongTasks: true,
    trackResources: true,
    version: process.env.GATSBY_DD_RUM_VERSION || '1.0.0',
    allowedTracingUrls: [
        'https://lighthouse-dev.apps.csts-k8cnp-ngl-1.r-caas.allstate.com',
      'https://lighthouse-dev.apps.csts-k8cnp-gl-1.r-caas.allstate.com',
      'https://lighthouse-uat.apps.csts-k8cnp-ngl-1.r-caas.allstate.com',
      'https://lighthouse-uat.apps.csts-k8cnp-gl-1.r-caas.allstate.com',
      'https://lighthouse-preprod.apps.csts-k8cpp-1.r-caas.allstate.com',
      'https://lighthouse.allstate.com'
    ],
    trackUserInteractions: true,
    trackFrustrations: true,
    sessionReplaySampleRate: 100,
    useCrossSiteSessionCookie: true,
    env: env,
  });
  datadogRum.setGlobalContextProperty('barometerit', '041800001bn8');
  datadogRum.setGlobalContextProperty('envlevel', envLevel);
  datadogRum.startSessionReplayRecording();
}

export const onRouteUpdate = ({ location }) => {
  datadogRum.addAction('Route Update', {
    path: location.pathname,
    search: location.search,
  })
}
